<template>
      <div class="content">
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-12">
                    <div class="nav-bar box-horizontal mb-0">
                      <i class="material-icons d-block text-secondary mr-2 pointer p-2" @click="$router.go(-1)">arrow_back</i>
                      <div class="flex-1">
                        <h3 class="m-0">Invoice</h3>
                        <p class="mb-0">Pembayaran via Online akan terperinci disini</p>
                      </div>
                    </div>
                    <div class="row mt-4">
                      <div class="col-md-12">
                        <div class="card mt-2">
                          <div class="card-body">
                            <div class="box-horizontal">
                              <div class="flex-1">
                                <span>Total Pembayaran</span>
                                <h3 class="mt-0 text-success">{{myGlobal.ribu(dataAll.saldo)}}</h3>
                                <div>
                                  <span class="text-warning d-block">Saldo Pending</span>
                                  <span class="text-warning h4">{{myGlobal.ribu(dataAll.saldoPending)}} <button class="btn btn-sm btn-info">Rincian</button></span>
                                </div>
                              </div>
                              <div>
                                <h4 class="text-right">Tarik Saldo</h4>
                                * Untuk penarikan harus via App Beatcom Network ya :)
                              </div>
                            </div>
                            
                            <div class="box-horizontal mb-0">
                                <div class="box-menu text-center pointer" @click="link.historySaldo()">
                                    <i class="material-icons d-block text-info">format_align_justify</i>
                                    History Invoice
                                </div>
                                <div class="box-menu text-center pointer" @click="link.historyWithdraw()">
                                    <i class="material-icons d-block text-success">request_quote</i>
                                    History Withdraw
                                </div>
                                <div class="box-menu text-center pointer" @click="link.historyTidakValid()">
                                    <i class="material-icons d-block text-danger">list</i>
                                    Pembayaran tidak valid
                                </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="card mt-2">
                      <div class="card-body">
                          <div class="bulan-box">
                            <span>Pilih Bulan dan Tahun</span>
                            <div class="box-horizontal">
                              <div class="form-group mr-2">
                                  <select class="form-control text-info" id="exampleFormControlSelect1" v-model="dataAll.bulan">
                                      <option :value="myGlobal.getBulan()" selected disabled>{{myGlobal.getBulanNow()}}</option>
                                      <option value="" disabled>Pilih Bulan</option>
                                      <option value="01">Januari</option>
                                      <option value="02">Februari</option>
                                      <option value="03">Maret</option>
                                      <option value="04">April</option>
                                      <option value="05">Mei</option>
                                      <option value="06">Juni</option>
                                      <option value="07">Juli</option>
                                      <option value="08">Agustus</option>
                                      <option value="09">September</option>
                                      <option value="10">Oktober</option>
                                      <option value="11">November</option>
                                      <option value="12">Desember</option>
                                  </select>
                              </div>
                              <div class="form-group mr-2">
                                  <select class="form-control text-info" id="exampleFormControlSelect1" v-model="dataAll.tahun">
                                      <option :value="myGlobal.getTahunNow()" selected disabled>{{myGlobal.getTahunNow()}}</option>
                                      <option value="" disabled>Pilih Bulan</option>
                                      <option value="2021">2021</option>
                                      <option value="2022">2022</option>
                                      <option value="2023">2023</option>
                                      <option value="2024">2024</option>
                                      <option value="2025">2025</option>
                                  </select>
                              </div>
                              <button class="btn btn-info" @click="theGet.History()">Filter</button>
                            </div>
                          </div>
                          <div class="table-responsive">
                          <table class="table">
                              <thead class="">
                                <th>Inv</th>
                                <th>Tanggal</th>
                                <th>Nama Pelanggan</th>
                                <th>Area</th>
                                <th>Paket</th>
                                <th>Via</th>
                              </thead>
                              <!-- LOADING -->
                              <tbody v-show="dataAll.loading">
                              <tr>
                                  <td colspan="8"><Loading></Loading></td>
                              </tr>
                              <tr>
                                  <td colspan="8"><Loading></Loading></td>
                              </tr>
                              <tr>
                                  <td colspan="8"><Loading></Loading></td>
                              </tr>
                              </tbody>
                              <!-- DATA -->
                              <tbody v-show="!dataAll.loading">
                              <tr v-for="(u, index) in theGet.data.List">
                                  <td>
                                    <strong >#{{u.id}}</strong>
                                  </td>
                                  <td>
                                    <span class="d-block">{{u.bayar_jam}}</span>
                                    <span class="d-block">{{myGlobal.tglIndo(u.bayar_tanggal)}}</span>
                                  </td>
                                  <td>
                                    <span class="d-block">{{u.unama}}</span>
                                    <span class="d-block">{{u.wa}}</span>
                                  </td>
                                  <td>
                                    {{u.uarea}}
                                  </td>
                                  <td>
                                      <div>
                                        <span class="d-block">{{u.paket_nama}}</span>
                                        <span class="d-block">{{ myGlobal.ribu(u.paket_tarif) }}</span>
                                      </div>
                                  </td>
                                  <td>
                                    <span style="text-transform: uppercase">{{u.via}}</span></br>
                                    <span v-if="u.stat_via_online == 'done'" class="text-success">Selesai</span>
                                    <span v-else class="text-warning">Menunggu Pembayaran</span>
                                  </td>
                                  <td>
                                    <button class="btn btn-sm btn-primary" @click="theGet.rincian(u)">Rincian</button>
                                  </td>
                              </tr>
                              <!-- NULL -->
                              <tr v-if="theGet.data.List == null">
                                  <td></td>
                                  <td  colspan="5">Tidak ada Data "{{myGlobal.BulanOnly(dataAll.tanggalCari)}}"</td>
                              </tr>
                              </tbody>
                          </table>
                          </div>
                      </div>
                      <div class="card-footer text-center" v-show="dataAll.page != 999">
                        <button class="btn btn-info" @click="theGet.loadmore()">Loadmore</button>
                      </div>
                    </div>
                </div>
                
            </div>
        </div>

        <!-- MODAL -->
        <div class="modal" tabindex="-1" role="dialog" v-show="dataAll.modalDetail">
            <div class="overlay"></div>
            <div class="modal-dialog" role="document" v-if="dataAll.modalData != null">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title">Rincian Transaksi</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="dataAll.modalDetail = false">
                    <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div class="modal-body" style="height: 500px; overflow: auto">
                    <div class="row">
                      <div class="col-md-12">
                        <label for="" class="text-secondary">Bulan Tagihan</label>
                        <p class="text-success">{{myGlobal.BulanOnly(dataAll.modalData.tanggal)}}</p>
                      </div>
                      <div class="col-md-12">
                        <label for="" class="text-secondary">Pelanggan</label>
                        <p class="mb-0">{{dataAll.modalData.unama}}</p>
                        <p class="">{{dataAll.modalData.wa}}</p>
                      </div>
                      <div class="col-md-12">
                        <label for="" class="text-secondary">Area</label>
                        <p class="">{{dataAll.modalData.uarea}}</p>
                      </div>
                      <div class="col-md-12">
                        <label for="" class="text-secondary d-block">Status</label>
                        <p class="text-warning" v-if="dataAll.modalData.stat_via_online == 'pending' || dataAll.modalData.stat_via_online == null">Pending</p>
                        <p class="text-success" v-else>Done</p>
                      </div>
                      <div class="col-md-12 mb-3">
                        <label for="" class="text-secondary d-block">Jam & Tanggal</label>
                        <span class="">{{dataAll.modalData.bayar_jam}} - {{myGlobal.tglIndo(dataAll.modalData.bayar_tanggal)}}</span>
                      </div>
                      <div class="col-md-12">
                        <label for="" class="text-secondary d-block">Paket</label>
                        <p class=" m-0">{{dataAll.modalData.paket_nama}}</p>
                        <p class=" m-0">{{myGlobal.ribu(dataAll.modalData.paket_tarif)}}</p>
                        <p class=" m-0">{{dataAll.modalData.rincian1}} - {{myGlobal.ribu(dataAll.modalData.biaya1)}}</p>
                        <p class="">{{dataAll.modalData.rincian2}} - {{myGlobal.ribu(dataAll.modalData.biaya2)}}</p>
                      </div>
                      <div class="col-md-12" v-if="dataAll.modalData.kerusakan != null">
                        <label for="" class="text-secondary d-block">Kerusakan</label>
                        <p class="text-warning">{{dataAll.modalData.kerusakan}}</p>
                      </div>
                      <div class="col-md-12" v-if="dataAll.modalData.teknisi != null">
                        <label for="" class="text-secondary d-block">Teknisi</label>
                        <p class="">{{dataAll.modalData.teknisi}}</p>
                      </div>

                      <!--
                      <div class="col-md-12" v-if="dataAll.modalData.ur_id != null">
                        <label for="" class="text-secondary d-block">Pelanggan</label>
                        <p>{{dataAll.detailPel}} - {{data.detailPelWA}} - {{dataAll.detailPelArea}}</p>
                      </div>
                      -->
                    </div>
                  </div>
                  <div class="modal-footer"> 
                    <button type="button" class="btn btn-info" @click="dataAll.modalDetail = false">Okelah</button>
                  </div>
              </div>
          </div>
        </div>


      </div>
</template>

<script>
import Vue from 'vue'
import moment from 'moment'

import { reactive } from '@vue/composition-api'
import myGlobal from '@/globalFunc/myGlobal' 
import inter from '@/globalFunc/Interface' 
import Loading from '@/globalFunc/Loading' 
import router from '@/router'

export default {
  name: 'Beranda',
	components: { 
      "Loading" : Loading
	}, 
  setup() {
    const dataAll = reactive({
      loading: true,
      bulan: '0',
      tahun: '0',
      saldo: "0",
      saldoPending: "0",
      modalData: null,
      modalDetail: false,
      page: 0,
      tanggalCari: null
    })

    const theGet = {
      data: reactive({
        List: [],
      }),
      History() {

        dataAll.tanggalCari = dataAll.tahun+'-'+dataAll.bulan+'-01';
        
        dataAll.loading = true;

        var datax = {
          token: 'TangTung '+myGlobal.Session('token'),
          tahun: dataAll.tahun,
          bulan: dataAll.bulan,
          page: dataAll.page
        };
    
        var apiUrl = inter.historyInvoice();
        myGlobal.call(datax,apiUrl).then(x => {
          
          //console.log(JSON.stringify(x));

          dataAll.loading = false;

          if (x.status == true) {
            if (theGet.data.List != null) {
              if (dataAll.page > 0) {
                // loadmore
                var i;
                for (i = 0; i < x.data.length; i++) {
                  theGet.data.List.push(x.data[i]);
                }
              } else {
                // new
                theGet.data.List = x.data;
              }
            } else {
              // new
              theGet.data.List = x.data;
            }
          } else {
            if (dataAll.page == 0) {
              theGet.data.List = null;
            } else {
              dataAll.page = 999;
            }
          }

        })
      },
      rincian(data) {
        //console.log(JSON.stringify(data));
        dataAll.modalData = data;
        dataAll.modalDetail = true;
      },
      Saldo() {
        var datax = {
          token: 'TangTung '+myGlobal.Session('token')
        };
    
        var apiUrl = inter.Saldo();
        myGlobal.call(datax,apiUrl).then(x => {
          
          //console.log(JSON.stringify(x));

          if (x.status == true) {
            var d = x.data;

            dataAll.saldo = d.total_history;
            dataAll.saldoPending = d.total_pending;

          } else {

          }

        })
      },
      loadmore() {
        if (dataAll.page != 999) {
          dataAll.page = dataAll.page + 1;
          theGet.History();
          console.log(dataAll.page);
        } else {
          alert("Ini data akhir maseh :)");
        }
      }
    }

    const link = {
      historySaldo() {
        router.push({ 
            name: 'invoice-history-saldo'
        });
      },
      historyWithdraw() {
        alert("Sedang di garap :)")
      },
      historyTidakValid() {
        alert("Sedang di garap :)")
      }
    }

    return {
      dataAll,
      myGlobal,
      theGet,
      link
    }
  },
  mounted () {
    document.title = "Invoice";

    this.dataAll.namaQ = sessionStorage.getItem('admin');

    this.dataAll.bulan = myGlobal.getBulan();
    this.dataAll.tahun = myGlobal.getTahunNow();
    
    this.theGet.History();
    this.theGet.Saldo();
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.modal {
  display: inherit;
}
.box-menu {
    padding: 15px;
}
.box-menu > i {
    font-size: 25pt;
}
</style>



// WEBPACK FOOTER //
// src/components/invoice/main.vue